var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.667842 9.6663C0.512074 9.66661 0.361117 9.61236 0.241175 9.51297C0.104837 9.39994 0.0190769 9.2373 0.0028175 9.06095C-0.0134419 8.8846 0.0411362 8.70903 0.154509 8.57297L3.14118 4.99964L0.261175 1.41964C0.149328 1.28191 0.0969962 1.10528 0.115765 0.928849C0.134534 0.752422 0.222856 0.590753 0.361175 0.479638C0.50062 0.356945 0.684927 0.297987 0.869691 0.31697C1.05446 0.335953 1.22292 0.431154 1.33451 0.579638L4.55451 4.57964C4.75672 4.82564 4.75672 5.1803 4.55451 5.4263L1.22118 9.4263C1.08553 9.58994 0.879999 9.67908 0.667842 9.6663Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow-Right.172fc8ee34e64246900afbefeeddba53.svg";
export { ForwardRef as ReactComponent };